// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__sYcmj","image":"Header_image__3ZRMa","name":"Header_name___oEAi","info":"Header_info__34izx","infoRow":"Header_infoRow__2Hm9a"};